import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import './AppLayout.css';
import SignIn from '../ui/authPopup/SignIn';
import SignUp from '../ui/authPopup/SignUp';
import useMainStore from '../../store/mainState';
import GLoader from '../ui/base/GLoader';
import { GET_USER } from '../../graphql/auth';
import { useMutation, useQuery } from '@apollo/client';
import Footer from './Footer';
import { EXIT_GAME } from '../../graphql/games';
import LoaderOverlay from '../ui/LoaderOverlay';
import ResetPassword from '../ui/authPopup/ResetPassword';
interface AppLayoutProps {
}

const AppLayout: React.FC<AppLayoutProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isLoggedIn, isLoading, isSignInOpen, setIsSignInOpen, user, setIsLoading, setUser, isSignUpOpen, setIsSignUpOpen, gameState, setGameState, isResetPasswordOpen } = useMainStore();
  const referralCode = searchParams.get('referral') || '';
  const storedReferral = useRef<string>('');

  // Store referral code when first detected
  useEffect(() => {
    if (referralCode) {
      storedReferral.current = referralCode;
    }
  }, [referralCode]);

  // Auto-open signup popup when referral param is present
  useEffect(() => {
    if (referralCode && !isLoggedIn) {
      setIsSignUpOpen(true);
    }
  }, []);

  // Preserve referral param across navigation
  useEffect(() => {
    if (storedReferral.current && !searchParams.get('referral')) {
      navigate(`${location.pathname}?referral=${storedReferral.current}`, { replace: true });
    }
  }, [location.pathname]);
  const userId = localStorage.getItem("userId");
  const [exitGame, { data: exitGameData, loading: exitGameLoading, error: exitGameError }] = useMutation(EXIT_GAME);

  const { loading: userLoading, error: userError, data: userData, refetch: refetchUser } = useQuery(GET_USER, {
    variables: { id: Number(userId) },
    skip: !userId, // Skip the query if no userId
    fetchPolicy: 'cache-and-network' // Always refetch from server
  });

  useEffect(() => {
    console.log({ location });

    if ((location.pathname == '/casino' || location.pathname == '/') && gameState) {
      setIsLoading(true)
      exitGame({
        variables: {
          sessionToken: gameState?.sessionToken,
        },
      }).then(async (data: any) => {
        const getUserData = await refetchUser();
        setGameState(null)
        setUser(getUserData?.data?.user)
        setIsLoading(false)
      }).catch((err: any) => {
        setIsLoading(false)
      })
    }
  }, [location.pathname, gameState]);

  useLayoutEffect(() => {
    if (userLoading) {
      setIsLoading(true);
    }
    if (userError) {
      setIsLoading(false);
    }
    if (userData) {
      setIsLoading(false);
      setUser(userData.user);
    }
  }, [userLoading, userError, userData]);

  // const [isSignInOpen, setIsSignInOpen] = React.useState(false);
  // const [isSignUpOpen, setIsSignUpOpen] = React.useState(false);
  const { isCollapsed, setIsCollapsed } = useMainStore();

  return (
    <div className="app-layout">
      <Header setIsSignInOpen={setIsSignInOpen} setIsSignUpOpen={setIsSignUpOpen} />
      <Sidebar />
      {/* Mobile backdrop */}
      {!isCollapsed && (
        <div
          className="fixed inset-0 top-[60px] bg-black/60 backdrop-blur-sm z-10 md:hidden"
          onClick={() => setIsCollapsed(true)}
        />
      )}
      <div className="main-content">
        <main className={location.pathname.includes('sport') ? "" : "p-[20px]"}>
          <Outlet />
        </main>
        <Footer />
      </div>

      {!isLoggedIn && (
        <>
          <SignIn isOpen={isSignInOpen} onClose={() => setIsSignInOpen(false)} openSignUp={() => setIsSignUpOpen(true)} />
          <SignUp isOpen={isSignUpOpen} onClose={() => setIsSignUpOpen(false)} openSignIn={() => setIsSignInOpen(true)} initialPromoCode={storedReferral.current || referralCode} />
          {isResetPasswordOpen && <ResetPassword />}
        </>
      )}

      {/* {isLoading && (
        <GLoader />
      )} */}
      {/* <LoaderOverlay
        isVisible={loading}
        backdrop="dark"
        variant="spinner"
        size="md"
        color="white"
      /> */}
    </div>
  );
};

export default AppLayout;